import "client-only";

import { userClient } from "@/lib/connect.client";
import {
  createUserWithClient,
  ensureUserProfileWithClient,
  followUserWithClient,
  getUserByIdWithClient,
  getUserFollowingInfoWithClient,
  listUserFollowersWithClient,
  listUserFollowingWithClient,
  setActiveOrgWithClient,
  unfollowUserWithClient,
} from "./users.base";

/**
 * getUserById gets a user by ID on the client.
 */
export const getUserById = getUserByIdWithClient(userClient);

/**
 * createUser creates a user on the client.
 */
export const createUser = createUserWithClient(userClient);

/**
 * getUserFollowingInfo gets following info for a user on the client.
 */
export const getUserFollowingInfo = getUserFollowingInfoWithClient(userClient);

/**
 * setActiveOrg sets the active organization for the current user on the client.
 */
export const setActiveOrg = setActiveOrgWithClient(userClient);

/**
 * followUser follows a user on the client.
 */
export const followUser = followUserWithClient(userClient);

/**
 * unfollowUser unfollows a user on the client.
 */
export const unfollowUser = unfollowUserWithClient(userClient);

/**
 * listUserFollowers lists followers of a user on the client.
 */
export const listUserFollowers = listUserFollowersWithClient(userClient);

/**
 * listUserFollowing lists users that a user follows on the client.
 */
export const listUserFollowing = listUserFollowingWithClient(userClient);

// Legacy function support for existing components
export const getUserFollowingInfoOptions = (
  userId: string,
  viewerId?: string,
) => ({
  queryKey: ["user", userId, "following-info", viewerId],
  queryFn: () => getUserFollowingInfo({ userId, viewerId }),
  staleTime: 1000 * 60 * 5, // 5 minutes
});

// ===================================================
// ========== Ensure User Profile ==========
// ===================================================
export const ensureUserProfile = ensureUserProfileWithClient(userClient);
